import { HexColor } from "@pepdirect/shared/types";

export type colorNames =
  | "darkGray"
  | "gray"
  | "mediumGray"
  | "lightGray"
  | "borderGray"
  | "lightestGray"
  | "red"
  | "green"
  | "white";

export const colors: Record<colorNames, HexColor> = {
  darkGray: "#222",
  mediumGray: "#666",
  gray: "#999",
  lightGray: "#f6f6f6",
  borderGray: "#e5e3e7",
  lightestGray: "#bcbcbc",
  red: "#a62635",
  green: "#00883f",
  white: "#fff",
};
